import React, { useEffect, useState } from 'react'
import { AiFillAudio } from 'react-icons/ai';
import { MdMicOff } from 'react-icons/md';

export default function VoiceRecorder({ onRecorded }) {

    const [recorder, setRecorder] = useState();
    const [ isRecording, setIsRecording ] = useState(false);

    useEffect(() => {
        if(isRecording) startRecording();
        if(!isRecording) stopRecording();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRecording, recorder])

    const startRecording = async () => {

        let chunks = [];
        const constraints = {
            audio: true,
            video: false
        }


        await navigator.mediaDevices
            .getUserMedia(constraints)
            .then(async function (stream) {
                console.log("Initializing Recorder ...");
                const audioRecorder = new MediaRecorder(stream);

                await audioRecorder.start();
                setRecorder(audioRecorder);

                //Make the mediaStream global
                window.mediaStream = stream;
                //Make the mediaRecorder global
                window.mediaRecorder = audioRecorder;
                // console.log(recorder.state);

                audioRecorder.ondataavailable = (e) => {
                    chunks.push(e.data);
                };
                audioRecorder.onstop = async () => {
                    const blob = new Blob( chunks, { type: "audio/mpeg" });
                    chunks = [];
                    onRecorded(blob);
                }
            }).catch(function (err) {
                console.log(err);
            });
    }

    const stopRecording = async () => {
        if(recorder){
            await window.mediaRecorder.stop();
            await window.mediaStream.getTracks().forEach(stm => stm.stop() );
            setRecorder(null);
        }
    }

  return (
    <div onClick={() => setIsRecording(prev => !prev)} className={`p-[5px] rounded-full text-xl cursor-pointer border-2  ${isRecording ? 'text-red-600 border-red-600 ' : 'text-primary border-primary'}`}>
        {isRecording && <MdMicOff />}
        {!isRecording && <AiFillAudio />}
    </div>
  )
}
